import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let el = document.head.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
    return () => el.setAttribute("content", "index, follow");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("sig_token", data.token);
      localStorage.setItem("sig_user", JSON.stringify(data.user));
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-steel-900 flex items-center justify-center px-5 font-body">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-steel-400 hover:text-white transition-colors mb-8 text-sm">
          <ArrowLeft size={16} /> Back to website
        </a>
        <div className="border border-steel-700 bg-steel-800 p-8 md:p-10">
          <div className="w-12 h-12 bg-steel-700 flex items-center justify-center mb-6"><Lock className="text-white" size={20} /></div>
          <h1 className="font-display font-black text-3xl text-white tracking-tighter">Admin Login</h1>
          <p className="text-steel-400 mb-8 mt-2">Sign in to manage leads.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="flex flex-col gap-2">
              <label className="font-label text-xs uppercase tracking-wider text-steel-400">Email</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="bg-steel-900 border border-steel-700 px-4 py-3 text-white focus:outline-none focus:ring-1 focus:ring-steel-400 focus:border-steel-400 transition-colors" />
            </div>
            <div className="flex flex-col gap-2">
              <label className="font-label text-xs uppercase tracking-wider text-steel-400">Password</label>
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="bg-steel-900 border border-steel-700 px-4 py-3 text-white focus:outline-none focus:ring-1 focus:ring-steel-400 focus:border-steel-400 transition-colors" />
            </div>
            {error && <div data-testid="login-error" className="text-red-400 text-sm">{error}</div>}
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full bg-white text-steel-900 font-bold py-3.5 flex items-center justify-center gap-2 hover:bg-steel-100 transition-colors disabled:opacity-60">
              {loading ? <><Loader2 className="animate-spin" size={18} /> Signing in...</> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
